module.exports = __webpack_public_path__ + "static/media/768-products---5-image-2.62655502.png";